/**
 * Grade Room — shot-type starting presets (P1 final polish).
 * Each preset appends ONE pre-configured node (all v1-contract ops, fully
 * renderable). Values are starting points, not finished grades.
 */
import { IDENTITY_CDL, IDENTITY_ADJUST } from "./gradeMath";

const preset = (label, cdl = {}, adjust = {}) => ({
  label,
  node: () => ({
    id: `n_${Date.now()}_${Math.floor(Math.random() * 1e4)}`,
    label,
    enabled: true,
    ops: {
      cdl: { ...IDENTITY_CDL(), ...cdl },
      adjust: { ...IDENTITY_ADJUST(), ...adjust },
      curves: {},
      lut_ref: null,
    },
  }),
});

export const SHOT_PRESETS = [
  preset("Product Hero",
    { gain: [0.04, 0.02, 0], lift: [-0.02, -0.02, -0.02] },
    { contrast: 1.18, saturation: 1.2 }),
  preset("Skin Protect",
    { gamma: [0.04, 0.01, -0.02] },
    { contrast: 1.05, saturation: 0.95, temp: 0.06 }),
  preset("Night Exterior",
    { lift: [-0.03, -0.02, 0.02], gain: [-0.05, -0.02, 0.06] },
    { contrast: 1.12, saturation: 0.85, temp: -0.18 }),
  preset("High-Key Commercial",
    { lift: [0.05, 0.05, 0.05], gamma: [0.06, 0.06, 0.06] },
    { contrast: 0.92, saturation: 1.08 }),
  preset("Teal & Orange",
    { lift: [-0.02, 0, 0.05], gain: [0.06, 0.01, -0.05] },
    { contrast: 1.15, saturation: 1.1, temp: 0.1 }),
  preset("Bleach Bypass",
    { gain: [0.03, 0.03, 0.03] },
    { contrast: 1.35, saturation: 0.45 }),
];
